import { render, staticRenderFns } from "./GpathCompanyList.vue?vue&type=template&id=2f9e9460"
import script from "./GpathCompanyList.vue?vue&type=script&lang=js"
export * from "./GpathCompanyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports